<template>
<div class="chapter">
<div class="inner_page">
<h1 class="book-title"><a id="page_iii"></a>Choke</h1>
<p class="author">Darnella Ford</p>
<p class="editor"><img alt="Images" src="images/pub.gif"/><br/>St. Martin’s Griffin<br/>New York<br/><img alt="Images" src="images/pub1.gif"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?16e39983